import {
  AfterViewInit,
  Component,
  forwardRef,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { GridComponent } from "app/modules/shared/components/grid/grid.component";
import { UtilService } from "@app/modules/shared/services/util.service";
import {
  ExplorerService,
  TabConfig,
} from "@app/modules/shared/services/explorer.service";
import { DynamicComponent } from "@app/data/dashboard/interfaces/dynamic-component.interface";
import { MaterialFormComponent } from "@dashboard/modules/material-management/material/components/material-form/material-form.component";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { CurrentAccountFormComponent } from "@dashboard/modules/finance-management/current-account/components/current-account-form/current-account-form.component";

@Component({
  selector: "kl-current-account-list",
  templateUrl: "./current-account-list.component.html",
  styleUrls: ["./current-account-list.component.scss"],
})
export class CurrentAccountListComponent implements OnInit, AfterViewInit {
  templateContext: any;
  openModal = false;
  currentItem: any;
  reportFilterData: any;
  alertShow: boolean;
  alertMessage: string;
  alertType: string;
  filterSelectItems = [
    {
      name: "code",
      description: "code",
    },
    {
      name: "description",
      description: "title",
    },
  ];
  filterObject: any;
  @Input() mode: string;
  @Input() tabId: string;
  @Input() modalId: string;
  @Input() dblSelect = false;
  @ViewChild(forwardRef(() => GridComponent), {
    static: true,
  })
  private gridComponent: GridComponent;
  dropdownActions = [
    {
      slug: "copy",
      method: (cell) => {
        if (this.utilService.isShow(this.tabId + ".006")) {
          this.gridComponent.alertShow = false;
          this.klLoadingService.show("loading");
          this.apiService
            .getDataById("current-account", cell.item.id)
            .subscribe(
              (response) => {
                if (response === undefined) {
                  this.handleError("error_data");
                } else {
                  const copyData = UtilService.deepCopy(response);
                  const tabConfig = <TabConfig>{
                    id: "currentAccountCopy" + response.id,
                    title: "current_account",
                    childTemplate: <DynamicComponent>{
                      mode: "copy",
                      tabId: "currentAccountCopy" + response.id,
                      template: CurrentAccountFormComponent,
                      dataContext: copyData,
                      service: "current-account",
                      isReadOnly: false,
                    },
                    isCloseable: true,
                  };
                  this.explorerService.openTab(tabConfig);
                }
              },
              (error) => this.handleError(error)
            );
        } else {
          this.handleError("not_authorized_to_perform_this_operation");
        }
      },
    },
  ];

  constructor(
    private apiService: ApiService,
    private explorerService: ExplorerService,
    private utilService: UtilService,
    private klLoadingService: KlLoadingService
  ) {}

  ngOnInit() {
    if (this.mode) {
      this.gridComponent.mode = this.mode;
    }
    if (this.templateContext) {
      this.gridComponent.templateContext = this.templateContext;
    }
    this.reportFilterData = {
      filter: {
        current_account: {
          id: null,
        },
      },
      query: {
        paging: {
          limit: 100,
          fetch: "EAGER",
        },
      },
    };
  }

  ngAfterViewInit(): void {
    if (this.dropdownActions.length > 0) {
      this.gridComponent.actions = this.dropdownActions;
    }
    if (this.mode) {
      this.gridComponent.mode = this.mode;
    }
  }

  handleError(error) {
    this.klLoadingService.hide();
    this.gridComponent.alertMessage = this.utilService.alertErrorMessage(error);
    this.gridComponent.alertType = "error";
    this.gridComponent.alertShow = true;
    this.gridComponent.changeDetector.markForCheck();
  }
}
